import React, { createContext, useState } from 'react';
import { ModalContextType, ModalOptions } from './type';
import { ModalRoot } from './ModalRoot';

export const ModalContext = createContext<ModalContextType | null>(null);

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
    const [modal, setModal] = useState<ModalOptions | null>(null);

    const openModal = (options: ModalOptions) => {
        setModal(options);
    };

    const closeModal = () => {
        setModal(null);
    };

    return (
        <ModalContext.Provider value={{ openModal, closeModal }}>
            {children}
            <ModalRoot modal={modal} onClose={closeModal} />
        </ModalContext.Provider>
    );
};